import { AsyncPipe, NgClass, NgTemplateOutlet } from '@angular/common';
import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  QueryList,
  TemplateRef,
  Type
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { FieldType, FieldTypeConfig, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FormlyFieldSelectProps, FormlySelectModule } from '@ngx-formly/core/select';
import { AutoComplete } from '@openng/optimus-ui/autocomplete';
import { Button } from '@openng/optimus-ui/button';
import { TemplateDirective } from '~ngx-shared/directives';
import { TemplateUtil } from '~ngx-shared/utils';
import { FieldWrapperProps } from '../../wrappers/field-wrapper/field-wrapper.component';

export interface AutoCompleteSelectProps extends FieldWrapperProps, FormlyFieldSelectProps {
  [key: string]: any;
  virtualScroll?: boolean;
  virtualScrollSize?: number;
  showClear?: boolean;
  forceSelection?: boolean;
  multiple?: boolean;
  optionLabel?: string | (string | ((item: any) => string));
  optionValue?: string | (string | ((item: any) => string));

  clickLabel?: string;
  clickIcon?: string;
  clickClass?: string;

  severity?: 'success' | 'info' | 'warn' | 'danger' | 'help' | 'primary' | 'secondary' | 'contrast';

  completeMethod?(
    event: { originalEvent: Event; query: string },
    field: FieldTypeConfig<AutoCompleteSelectProps>
  ): void;

  clickMethod?(event: MouseEvent, field: FieldTypeConfig<AutoCompleteSelectProps>): void;
}

export interface AutoCompleteSelectFieldConfig extends FormlyFieldConfig<AutoCompleteSelectProps> {
  type?: 'autocomplete-select' | Type<AutoCompleteSelectTypeComponent>;
}

@Component({
  selector: 'lib-formly-auto-complete-select-type',
  templateUrl: './auto-complete-select-type.component.html',
  styleUrl: './auto-complete-select-type.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgTemplateOutlet,
    TranslocoDirective,
    AutoComplete,
    ReactiveFormsModule,
    FormlyModule,
    NgClass,
    Button,
    AsyncPipe,
    FormlySelectModule
  ]
})
export class AutoCompleteSelectTypeComponent
  extends FieldType<FieldTypeConfig<AutoCompleteSelectProps>>
  implements AfterContentInit
{
  @ContentChildren(TemplateDirective) templates: QueryList<TemplateDirective>;

  protected readonly optionValueOf = TemplateUtil.getOptionValue;

  headerTemplate: TemplateRef<any> | null = null;
  emptyTemplate: TemplateRef<any> | null = null;
  selectedTemplate: TemplateRef<any> | null = null;
  suggestionTemplate: TemplateRef<any> | null = null;
  footerTemplate: TemplateRef<any> | null = null;

  ngAfterContentInit(): void {
    TemplateUtil.setTemplates(this, this.templates, [
      {
        template: 'headerTemplate',
        name: 'header'
      },
      {
        template: 'suggestionTemplate',
        name: 'suggestion'
      },
      {
        template: 'selectedTemplate',
        name: 'selected'
      },
      {
        template: 'emptyTemplate',
        name: 'empty'
      },
      {
        template: 'footerTemplate',
        name: 'footer'
      }
    ]);
  }

  getValueAsString(data: any, field: string): string {
    return TemplateUtil.getValueAsString(data, field);
  }
}
